<template>
  <div class="index-register">
    <div class="img" @click="gotoRegister"></div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  name: 'index-register',
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    gotoRegister() {
      this.SHOW_LOGIN_BOX({ page: 5 });
    },
  },
};
</script>
<style lang="less" scoped>
.index-register{
  width: 100%;
  padding-top: 48px;
  .img{
    cursor: pointer;
    width: 100%;
    height: 150px;
    background: url(../../../assets/imgs/homepage/not-login-footer2.png) no-repeat center/cover;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/index/components/index-register.vue